import React, { useState } from "react";
import "Pages/JobsLibrary/SbJobsLibrary.scss";
import ProfileViewTable from "./ProfileViewTable/ProfileViewTable";
import HeaderSection from "Components/HeaderSection/HeaderSection";
import ToasterModal from "Components/SbErrorToasterComponent/SbErrorToaster";
import { useSelector, useDispatch } from "react-redux";
import { hideToast, createJobCode } from "Store/actions/profileListActions";
import Permission from "Components/Permission";
import { Button, Card } from "react-bootstrap";
import SbJobCodeDrawer from "Components/SbJobCodeDrawer/SbJobCodeDrawer";
const ProfileEntitlements = () => {
  const [showNewProfileRow, setShowNewProfileRow] = useState(false);
  const { show, message, type: toastType } = useSelector(
    (state) => state.profileList.toast
  );
  const dispatch = useDispatch();

  const [isJobCodeDrawerOpen, setIsJobCodeDrawerOpen] = useState(false);
  const [jobCodeSaving, setJobCodeSaving] = useState(false);

  const tableProps = {
    showNewProfileRow,
    setShowNewProfileRow,
  };

  return (
    <>
      <div className="jobs-library-container shadow-sm">
        <HeaderSection
          title="Manage Profiles"
          description="A descriptive body text comes here"
        >
          <div className="d-flex align-items-center">
            <Permission resource="profile" actions={["create"]}>
              <Card.Text className="mb-0">
                <small className="text-body-tertiary jobs-description mb-0 me-3">
                  Create new profile:
                </small>
              </Card.Text>

              <Button
                className="btn btn-primary btn-md me-2 create-button btn-large icon-wrapper"
                onClick={() => setShowNewProfileRow(true)}
              >
                Create New Profile
              </Button>


            </Permission>
          </div>
        </HeaderSection>

        <ProfileViewTable {...tableProps} />

        <ToasterModal
          message={message}
          show={show}
          type={toastType}
          onClose={() => dispatch(hideToast())}
        />

        {isJobCodeDrawerOpen && (
          <SbJobCodeDrawer
            isOpen={isJobCodeDrawerOpen}
            saving={jobCodeSaving}
            onClose={() => setIsJobCodeDrawerOpen(false)}
            onSave={async (payload) => {
              try {
                setJobCodeSaving(true);

                const apiPayload = {
                  job_code: payload.jobCode?.trim(),
                  job_title: payload.companyJobTitle?.trim(),
                  job_family_name: payload.genericJobTitle?.trim(),
                  business_unit: payload.businessUnit,
                  legal_entity: payload.legalEntity,
                  level: payload.jobLevel,
                  role_type: payload.roleType,
                  role_status: payload.roleStatus,
                  work_environment: "Hybrid",
                };

                const ok = await dispatch(createJobCode(apiPayload));

                // IMPORTANT: return true/false so SbJobCodeDrawer can show success screen
                return ok;
              } finally {
                setJobCodeSaving(false);
              }
            }}
          />
        )}

      </div>
    </>
  );
};

export default ProfileEntitlements;
